import { connect } from 'react-redux'
import { withRouter, browserHistory } from 'react-router'
import { getTranslate } from 'react-localize-redux'
import cx from 'classnames'

import { getUser } from 'common/selectors/user'
import { getSelectedProject } from 'common/selectors/projects'
import * as Routes from 'constants/Routes'
import { workspaceNavItems, projectNavItems } from 'constants/navItems'
import styles from './NavTabs.module.scss'

const WORKSPACE_PATHS = [Routes.PROJECTS, Routes.DEVICES, Routes.INTEGRATIONS]
const NO_TABS_PATHS = [Routes.PROFILE, Routes.VISUALISATION]

/**
 * The row of tabs under the top bar. It shows the workspace tabs (My Projects,
 * My Devices, My Integrations) on the workspace pages, and the project tabs
 * (Dashboard, Shareables, ...) inside a project. It shows nothing on pages
 * like Account Settings or Visualisation. Manager-only tabs are hidden from viewers.
 */
const NavTabs = ({ translate, location, user, project }) => {
  const { pathname } = location

  const isWorkspace = WORKSPACE_PATHS.some(path => pathname.includes(path))
  const hasNoTabs = NO_TABS_PATHS.some(path => pathname.includes(path))

  if (hasNoTabs) return null

  const items = isWorkspace ? workspaceNavItems : projectNavItems

  // The user's role inside the open project (for example 'viewer' or 'manager').
  const getUserRole = () => {
    const projectData = project?.toJS?.()
    const userId = user?.toJS?.()?._id
    return projectData?.Meta?.ProjectCustomers?.[userId]?.role || ''
  }
  const userRole = getUserRole()

  const isActive = item => {
    // The Dashboard tab points to HOME but the page lives on the DASHBOARD route.
    if (item.route === Routes.HOME && pathname.includes(Routes.DASHBOARD)) return true
    return pathname.includes(item.route)
  }

  return (
    <nav className={cx(styles.navTabs, isWorkspace ? styles.workspace : styles.project)}>
      {items.map(item => {
        if (userRole === 'viewer' && item.isForManager) return null
        return (
          <button
            key={item.route}
            type='button'
            className={cx(styles.tab, { [styles.activeTab]: isActive(item) })}
            onClick={() => browserHistory.push(item.route)}
          >
            <span className={styles.fullLabel}>{translate(item.translation)}</span>
            {item.shortTranslation && (
              <span className={styles.shortLabel}>{translate(item.shortTranslation)}</span>
            )}
          </button>
        )
      })}
    </nav>
  )
}

const mapStateToProps = state => ({
  translate: getTranslate(state.localize),
  user: getUser(state),
  project: getSelectedProject(state)
})

export default withRouter(connect(mapStateToProps)(NavTabs))
